module.exports = __webpack_public_path__ + "img/gateway.be22f0f4.svg";